import React, { useEffect, useState } from 'react';
// import sixth_img_one from '../../assets/images/home-sixth-one.png';
// import sixth_img_two from '../../assets/images/home-sixth-two.png';
// import sixth_img_three from '../../assets/images/home-sixth-three.png';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { PodcastGet } from '../../Redux/Auth/Auth_Action';
import { toast } from 'react-toastify';

const RecentPodcast = () => {
    const dispatch = useDispatch();
    const [state, setState] = useState({ stateData: [] });

    const getPodcast = () => {
        dispatch(PodcastGet())
            .then((res) => {
                // console.log("working podcast", res.data);
                setState({ ...state, stateData: res.data });
            }).catch((e) => {
                // console.log(e, 'error from podcast');
                toast.error("Network Error");
            })
    }

    useEffect(() => {
        getPodcast();
    }, [])

    return (
        <div>
            <div className='row px-5 px-rezz'>
                <div className="col-lg-12 text-center mt-5">
                    <p className="f-30 f-mon-reg text-white mb-0 txt-captl">
                        Podcast Section
                    </p>
                    <p className="f-50 f-mon-bold text-white lh-01 mt-1 txt-captl">
                        Listen to experts
                    </p>
                    <div className="border-btm-pink-secondsec my-3">
                    </div>
                    <p className="wdth-80-per text-white f-mon-light f-20 mt-3 mb-5">
                        I along with many other top sports betting experts sit together to evaluate and share our thoughts on various matches, line moves, and thoughts on who will win making us the best sports predictions podcast.
                    </p>
                </div>
                {state?.stateData?.slice(0, 3)?.map((item, index) => {
                    return (

                        <div key={index} className='col-lg-4 text-center mt-2 mb-2'>
                            <Link to={`/singlepodcast/${item.id}`}
                                state={{ data: item, other_items: state?.stateData?.data }}>
                                {(item.media_url.slice(-3) === "mp4")
                                    ?
                                    <video width="100%" height="300" controls controlsList="nodownload" >
                                        <source src={`${item?.media_url}`} type="video/mp4" />
                                    </video>
                                    :
                                    <img src={item.media_url} className="img_home_sixth" alt="sixth img" />
                                }
                            </Link>
                        </div>
                    )
                })}

                {/* 
                <div className='col-lg-4 text-center mt-2 mb-2'>
                    <img src={sixth_img_three} className="img_home_sixth" alt="sixth img" />
                </div> 
                */}


                <div className='col-lg-12 text-center mt-5 mt-norez-rect-hm'>
                    <Link to='/podcast' className="btn btn-light f-16 f-mon-reg btn-pink-now mb-5 mt-5 pad-btn-ho-fifth mb-norez-rect-hm">
                        VIEW MORE
                    </Link>
                </div>
            </div>
        </div >
    );
};

export default RecentPodcast;